import React, { Component } from "react";
import Cookies from "../presentational/Cookies/";
import lscache from "lscache";

class CookiesContainer extends Component {
  state = {
    hasReadCookies: lscache.get("hasReadCookies")
  };

  setReadCookies = () => {
    lscache.set("hasReadCookies", true);
    this.setState({
      hasReadCookies: true
    });
  };

  render() {
    if (this.state.hasReadCookies !== null) return null;
    return <Cookies setReadCookies={this.setReadCookies} />;
  }
}

export default CookiesContainer;



// WEBPACK FOOTER //
// ./src/containers/Cookies.js